import { Field, withForm } from './finalForm';
import PropTypes from 'prop-types';
import appConfig from '../configs/appConfig';

import renderField from './render/renderField';
import { validateSecondStep } from './validate/validateSignUpForm';


const SignUpForm = (props) => {
  const { handleSubmit, submitting } = props;
  const appSiteUrl = appConfig.APP_SITE_URL;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="firstName"
        type="text"
        component={renderField}
        label="Имя"
      />
      <Field
        name="lastName"
        type="text"
        component={renderField}
        label="Фамилия"
      />
      <Field
        name="email"
        type="email"
        component={renderField}
        label="Email"
        disabled
      />
      <Field
        name="password"
        type="password"
        component={renderField}
        label="Пароль"
      />
      <Field
        name="confirmPassword"
        type="password"
        component={renderField}
        label="Подтвердите пароль"
      />
      <div className="auth-btns-wrap">
        <button
          type="submit"
          className="button"
          disabled={submitting}
        >
          Зарегистрироваться
        </button>
        <button
          type="button"
          className="button button_color_dark-blue"
          onClick={() => window.location.assign(`${appSiteUrl}/signup`)}
        >
          Регистрация работодателя
        </button>
      </div>
    </form>
  );
};

SignUpForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default withForm({
  form: 'signUp',
  validate: validateSecondStep,
})(SignUpForm);
